import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Academics from './Academics';
import CollegeCoachActivity from '../CollegeCoachActivity';
import CollegeFitTool from './CollegeFitTool';
import CollegeRecruitingAgency from './CollegeRecruitingAgency';
import CollegeRecruitingVideos from './CollegeRecruitingVideos';
import CollegeRecruitmentStatus from './CollegeRecruitmentStatus';
import CollegeSocial from './CollegeSocial';
import MyTargetColleges from './MyTargetColleges';
import PrimaryContact from './PrimaryContact';
import RecommendedEvents from './RecommendedEvents';
import { getPlayerStudentInfo } from '../../../actions/profile-actions';
import useCPPTracking from '../../hooks/useCPPTracking';
import { CppPlayerActions } from '../../Analytics/constants';
import styles from './collegeProspectTab.scss';

const CollegeProspectTab = () => {
    const dispatch = useDispatch();
    const claimedPlayerId = useSelector((state) => state.auth?.user?.claimedPlayer?.playerId);
    const profilePlayerId = useSelector((state) => state.profile?.data?.id);
    const hasStudentInfo = useSelector((state) => Boolean(state.profile?.data?.studentInfo));
    const { trackPlayerEngagement } = useCPPTracking();

    const [targetCollegesRefreshKey, setTargetCollegesRefreshKey] = useState(0);
    const [addedClubIds, setAddedClubIds] = useState(() => new Set());

    const handleTargetCollegeAdded = (clubId) => {
        setTargetCollegesRefreshKey(prev => prev + 1);
        if (typeof clubId !== 'number') {
            return;
        }
        setAddedClubIds((prev) => {
            if (prev.has(clubId)) {
                return prev;
            }
            const next = new Set(prev);
            next.add(clubId);
            return next;
        });
    };

    const handleTargetCollegeRemoved = (clubId) => {
        if (typeof clubId !== 'number') {
            return;
        }
        setAddedClubIds((prev) => {
            if (!prev.has(clubId)) {
                return prev;
            }
            const next = new Set(prev);
            next.delete(clubId);
            return next;
        });
    };

    const handleTargetCollegesLoaded = (clubIds) => {
        setAddedClubIds(new Set(clubIds));
    };

    const playerId = profilePlayerId || claimedPlayerId;

    useEffect(() => {
        if (!hasStudentInfo && playerId) {
            dispatch(getPlayerStudentInfo(playerId));
        }
    }, [dispatch, hasStudentInfo, playerId]);

    useEffect(() => {
        trackPlayerEngagement(CppPlayerActions.CPP_TAB_VIEWED);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fire-once: re-firing on state changes would duplicate the tab-viewed analytics event
    }, []);

    return (
        <div className={`tab-content ${styles.collegeProspectTabContent}`}>
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-8">
                        <MyTargetColleges
                            refreshKey={targetCollegesRefreshKey}
                            onCollegeAdded={handleTargetCollegeAdded}
                            onCollegeRemoved={handleTargetCollegeRemoved}
                            onCollegesLoaded={handleTargetCollegesLoaded}
                        />
                        <CollegeCoachActivity
                            onAddSuccess={handleTargetCollegeAdded}
                            addedClubIds={addedClubIds}
                        />
                        <CollegeFitTool
                            onAddSuccess={handleTargetCollegeAdded}
                            addedClubIds={addedClubIds}
                        />
                        <RecommendedEvents />
                    </div>
                    <div className="col-12 col-lg-4">
                        <Academics />
                        <PrimaryContact />
                        <CollegeRecruitingAgency />
                        <CollegeRecruitingVideos />
                        <CollegeSocial />
                        <CollegeRecruitmentStatus />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CollegeProspectTab;
